const auth = {
    'auth.register': 'Register',

    'auth.login': 'Einloggen',
    'auth.login_as': 'Anmelden als',
    'auth.login_as.reseller': 'Melden Sie sich als Reseller an',
    'auth.login_as.client': 'Log ist als Kunde',
    'auth.login.error': 'Falsche Kombination von E-Mail-Adresse und Passwort!',
    'auth.login.sub.error': 'Make sure you activate your account first. there is an email send to the email we know',

    'auth.logout': 'Ausloggen',

    'auth.forgot_password': 'Passwort vergessenassword',
    'auth.forgot_password.explanation': 'Geben Sie unten Ihre E-Mail-Adresse ein. Wir senden Ihnen eine E-Mail mit einem Link, über den Sie ein neues Passwort festlegen können.',
    'auth.forgot_password.ok': 'E-Mail zum Zurücksetzen des Passworts wurde erfolgreich gesendet!',
    'auth.forgot_password.error': 'E-Mail-Adresse wird nicht erkannt.',

    'auth.reset_password': 'Reset Passwort',
    'auth.reset_password.ok': 'Ihr Passwort wurde erfolgreich geändert!',
    'auth.reset_password.error': 'Beim Ändern Ihres Passworts ist ein Fehler aufgetreten',

    'auth.send_password': 'Passwort senden',

    'auth.back_to_login': 'Zurück zum Login',

    'auth.my_account': 'Mein Konto',
};

export default auth;
